<template>
  <div class="report-table-wrapper">
    <CCTable :data="data" :columns="columns" :defaultColumns="defaultColumns" :namespace="namespace" :paginationOptions="paginationOptions"
             :fieldNameDropDown="fieldNameDropDown" :dropDownMenuUrls="dropDownMenuUrls"
             :editableFieldsList="editableFieldsList"
             showSearchBar showExportButton>

             <!--:customTableHeadTemplate="$options.components.customTableHeadTemplate"
             :customTableBodyTemplate="$options.components.customTableBodyTemplate"
             :customTableHeadDatesComparisonTemplate="$options.components.customTableHeadDatesComparisonTemplate"
             :customTableHeadSellingPartnersTemplate="$options.components.customTableHeadSellingPartnersTemplate"
             :customTableBodyDynamicFieldTemplate="$options.components.customTableBodyDynamicFieldTemplate"-->

      <template v-if="!$md.mobile()">
        <h4 slot="cc-table-header" class="table-header-title">
            <span v-if="selectedSites != null">
                Adgroups for
                {{prepareSelectedOptionsNames(selectedSites, 'name')}}
            </span>
        </h4>
      </template>
    </CCTable>
    <CCTableRightSideBar :data="chartsData" :namespace="namespace" showChartsButton v-show="chartsData"></CCTableRightSideBar>
  </div>
</template>

<script>

  import '@/style/reports/base_table_style.scss';

  import CCTable from '@/components/reports/common/table/CCTable';
  import CCTableRightSideBar from '@/components/reports/common/table/CCTableRightSideBar';
  import baseTableMixin from '@/components/mixins/baseTableMixin';

  import {fieldNameDropDown, dropDownMenuUrls, editableFieldsList} from '@/configs/adgroup-report-config';

  //import customTableHeadTemplate from '@/components/reports/adgroupReport/templates/customTableHeadTemplate';
  //import customTableHeadDatesComparisonTemplate from '@/components/reports/adgroupReport/templates/customTableHeadDatesComparisonTemplate';
  //import customTableHeadSellingPartnersTemplate from '@/components/reports/adgroupReport/templates/customTableHeadSellingPartnersTemplate';

  //import customTableBodyTemplate from '@/components/reports/adgroupReport/templates/customTableBodyTemplate';
  //import customTableBodyDynamicFieldTemplate from '@/components/reports/adgroupReport/templates/customTableBodyDynamicFieldTemplate';

  export default {
    name: "cc-adgroup-report-table",
    components: {
      CCTable,
      CCTableRightSideBar,
      //customTableHeadTemplate,
      //customTableHeadDatesComparisonTemplate,
      //customTableHeadSellingPartnersTemplate,
      //customTableBodyTemplate,
      //customTableBodyDynamicFieldTemplate
    },
    mixins: [
      baseTableMixin
    ],
    props: {
      data: {
        type: Array,
        required: true
      },
      columns: {
        type: Array,
        required: true
      },
      defaultColumns: {
        type: Array,
        required: true
      },
      namespace: {
        type: String,
        required: true
      }
    },
    data(){
      return {
        chartsData: null,
        openChartsSideBar: this.$store.getters[this.namespace + '/getSideBarStatus'],
        fieldNameDropDown: fieldNameDropDown,
        dropDownMenuUrls: dropDownMenuUrls,
        editableFieldsList: editableFieldsList
      }
    },
    computed: {
      selectedSites: function(){
        let sites = this.$store.getters.getSitesList;
        let selectedSitesIds = this.$store.getters[this.namespace + '/getFilterValueByFilterName']('siteId');

        if (selectedSitesIds.length)
        {
          return sites.filter(item => selectedSitesIds.includes(item.id));
        }

        return null;
      },
    },
    created: function(){
      this.$store.watch(() => this.$store.getters[this.namespace + '/getReportChartsData'], (chartsData) => this.updateChartsData(chartsData));
    },
    beforeMount: function(){
      /*if (this.$store.getters[this.namespace + '/getReportColumns'].length == 0)
      {
        this.$store.dispatch(this.namespace + '/setReportColumns', this.columns);
      }*/
    },
    mounted: function(){
      //this.openChartsSideBar = this.$store.getters[this.namespace + '/getSideBarStatus'];
    },
    methods: {
      updateChartsData: function(chartsData){
        this.chartsData = chartsData;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/adgroupReport/CCAdgroupReportTable.vue